import { styled } from "@mui/system";
import { Button } from "@mui/material";

export const StyledHeader = styled("div")(({ theme, logoType, isIslamic, isElite }) => {
  let headerBgColor;

  if (isElite) {
    headerBgColor = theme.constants.eliteColor;
  } else if (isIslamic) {
    headerBgColor = theme.constants.islamicColor;
  } else {
    headerBgColor = theme.constants.conventionalColor;
  }
  return {
    position: "fixed",
    top: 0,
    zIndex: 2,
    display: "flex",
    width: "100%",
    height: "6rem",
    padding: "2rem 0.9375rem",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    backgroundColor: headerBgColor,
    gap: "1rem",
    [theme.breakpoints.up("md")]: {
      padding: "2rem 3.75rem",
      gap: "2rem"
    },
    "& .logo": {
      // height: "2rem",
      // width: "7.038rem",
      width: "100%",
      height: "2.5rem",
      [theme.breakpoints.up("md")]: {
        height: "2.5rem"
        // width: "8.8rem"
      }
    },
    "& .disabled": {
      pointerEvents: "none"
    },
    "& .applicationOverviewTrackNSwitch": {
      marginTop: 0,
      marginRight: 0,
      "& .MuiButton-root": {
        boxSizing: "border-box",
        display: "flex",
        width: "auto",
        height: "2.5rem",
        padding: "0.75rem 1.25rem",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem",
        borderRadius: "62.5rem",
        background: "#FFF",
        color: "#000",
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: "1.25rem",
        letterSpacing: "0rem",
        "&.switchAccountBtn": {
          background: "transparent",
          border: "1px solid #FFF",
          color: "var(--colour-text-light, #FFF)"
        }
      }
    },
    "& .saveNCloseHeader": {
      "& .MuiButton-root": {
        display: "flex",
        minWidth: "8.6875rem",
        height: "2.5rem",
        padding: "0.75rem 1.25rem",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "62.5rem",
        background: "#FFF",
        color: theme.palette.text,
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: "1.25rem",
        letterSpacing: "0rem",
        textTransform: "none"
      }
    },
    "& .headerAction": {
      display: "flex",
      flexDirection: "row",
      gap: "1rem"
    }
  };
});

export const StyledHeaderButton = styled(Button)(({ theme }) => ({
  display: "flex",
  minWidth: "8.6875rem",
  height: "2.5rem",
  padding: "0.75rem 1.25rem",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "62.5rem",
  background: "#FFF",
  color: "var(--colour-text-primary, #000)",
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "1.25rem",
  letterSpacing: "0rem",
  textTransform: "none",
  "&:hover": {
    background: "#FFF",
    border: "1px solid var(--colour-text-primary, #000)"
  }
}));
